export const ADD_OPTION = 'ADD_DIRECTION';
export const REMOVE_OPTION = 'REMOVE_DIRECTION';
export const RESET_OPTIONS = 'RESET_OPTIONS';
